import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
// eslint-disable-next-line import/no-named-as-default
import TestimonialCard from 'root/src/client/web/static/Testimonials/TestimonialCard'
import { ltGtMediaQuery, gtSmMediaQuery, gtMdMediaQuery } from 'root/src/client/web/commonStyles'

const style = {
	root: {
		display: 'flex',
		justifyContent: 'center',
		margin: 50,
		[gtMdMediaQuery]: {
			margin: 150,
		},
	},
	testimonialsContainer: {
		display: 'flex',
		width: '55vw',
		justifyContent: 'space-around',
		[gtSmMediaQuery]: {
			minHeight: 560,
			minWidth: 860,
		},
		[ltGtMediaQuery]: {
			flexDirection: 'column',
		},
	},
	left: {
		margin: [[0, 0, 175]],
		[ltGtMediaQuery]: {
			margin: [[0, 0, 100]],
		},
	},
	right: {
		margin: [[175, 0, 0]],
		[ltGtMediaQuery]: {
			margin: [[0, 0, 100]],
		},
	},
}

const Testimonials = ({
	pageContent, classes,
}) => (
	<div className={classes.root}>
		<div className={classes.testimonialsContainer}>
			<TestimonialCard {...pageContent.testimonialItems[0]} className={classes.left} />
			<TestimonialCard {...pageContent.testimonialItems[1]} className={classes.right} />
		</div>
	</div>
)

export default withStyles(style, { name: 'MuiTestimonials' })(memo(Testimonials))
